import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { Router } from "@angular/router";
import { ProfileService } from "../profile.service";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import * as CryptoJS from "crypto-js";
import { NgxSpinnerService } from "ngx-spinner";
import * as moment from "moment";
import { DateAdapter } from "@angular/material/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { OtpModelComponent } from "./otp-model/otp-model.component";
import { Ng2TelInput } from "ng2-tel-input";
@Component({
  selector: "app-edit-profile",
  templateUrl: "./edit-profile.component.html",
  styleUrls: ["./edit-profile.component.css"],
  providers: [Ng2TelInput],
})
export class EditProfileComponent implements OnInit {
  id: any;
  model: any = {
    name: "",
    mobile_number: "",
    email: "",
    image: "",
    gender: "",
  };
  @ViewChild("profileImage")
  profileImage!: ElementRef;
  btnDisable = true;
  countryCode: any;
  phoneNumber: any;
  selectedFile: any;
  image_type: any;
  base64textString: any = "";
  image: any;
  isNoSame = true;
  appConstant: any;
  newImage: any;
  isActive = true;
  minDate = moment().subtract(100, "years").format("YYYY-MM-DD");
  maxDate = moment().subtract(18, "years").format("YYYY-MM-DD");
  disableStatus = false;
  showError = false;
  nextPage = false;
  encryptedData: string;
  isLoading = false;
  @ViewChildren("input") input: ElementRef;
  models: any = {};
  mobile_number: any;
  constructor(
    private toastr: ToastrService,
    public profileService: ProfileService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private dateAdapter: DateAdapter<Date>,
    public dialog: MatDialog,
    public Ng2TelInput: Ng2TelInput,
    private ref: ChangeDetectorRef,
    public dialogRef: MatDialogRef<EditProfileComponent>
  ) {
    this.dateAdapter.setLocale("en-US");
    this.appConstant = environment;
    dialogRef.disableClose = true;

    // Get user data from localStorage.
  }

  ngOnInit(): void {
    this.isNoSame = false;
    const userInfo = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem(environment.localStorageKey),
        environment.secretkey
      ).toString(CryptoJS.enc.Utf8)
    );

    this.model = userInfo;
    this.models.mobile_number = this.model.mobile_number;
    this.countryCode = this.model.country_code;
    this.mobile_number = this.model.mobile_number;
    this.image = userInfo.image;
    this.isActive = true;
  }

  handleFileSelect(evt) {
    this.selectedFile = evt.target.files[0];
    const files = evt.target.files;
    if (files.length > 0) {
      this.disableStatus = true;
      const file = files[0];
      const type = file.type;
      const image_type = type.split("/");
      this.image_type = image_type[1];
      this.profileService.uploadImage(this.selectedFile).subscribe(
        (res) => {
          res
            ? this.profileService
                .uploadFileToS3(res, this.selectedFile)
                .subscribe(() => {
                  this.disableStatus = false;
                  // this.showImg = true;
                  //this.toastr.success('Image Upload SuccessFully', 'Success!');
                })
            : "";
        },
        (err) => {
          this.disableStatus = false;
          if (err.status === 0) {
            this.toastr.error("CONNECTION REFUSED", "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 500) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 404) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 401) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          }
        }
      );
      // }
    }
  }

  // _handleReaderLoaded(readerEvt) {
  //   const binaryString = readerEvt.target.result;
  //   this.base64textString = btoa(binaryString);
  // }

  onUpdate(form) {
    if (form) {
      this.profileService.isLoading = true;
      // (this.model.image = this.newImage ? this.newImage : ""),
      this.profileService.uploadedFile
        ? (this.model.image = this.profileService.uploadedFile.split("/").pop())
        : "";
      this.profileService.EditProfile(this.model).subscribe(
        (res) => {
          this.profileService.isLoading = false;
          this.model = res;
          this.image = res.image;
          const userInfo = JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem(environment.localStorageKey),
              environment.secretkey
            ).toString(CryptoJS.enc.Utf8)
          );
          userInfo.name = res.name;
          userInfo.email = res.email;
          userInfo.image = res.image;
          userInfo.date_of_birth = res.date_of_birth;
          userInfo.gender = res.gender;
          const encryptData = CryptoJS.AES.encrypt(
            JSON.stringify(userInfo),
            environment.secretkey
          ).toString();
          localStorage.setItem(environment.localStorageKey, encryptData);
          this.toastr.success(res.message, "Success!", {
            closeButton: true,
          });
          this.onRefresh();
          this.dialog.closeAll();
          this.router.navigate(["/my-account/profile"]);
        },
        (err) => {
          this.profileService.isLoading = false;
          this.toastr.error(err.datas.message, "OOPS!", {
            closeButton: true,
          });
        }
      );
    }
  }
  onRefresh() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    const currentUrl = this.router.url + "?";
    this.router.navigateByUrl(currentUrl).then(() => {
      this.router.navigated = false;
      this.router.navigate([this.router.url]);
    });
  }
  remove() {
    this.dialog.closeAll();
    this.isActive = false;
  }

  onSubmit(form) {
    if (form) {
      if (
        !this.btnDisable &&
        JSON.stringify(this.model.mobile_number) !== this.mobile_number
      ) {
        this.spinner.show();
        this.isLoading = true;
        let model_data;
        if (this.phoneNumber) {
          model_data = {
            code: this.countryCode,
            mobile: this.phoneNumber.replace("+" + this.countryCode, ""),
            country_name: this.models.country ? this.models.country : "us",
          };
        } else {
          model_data = {
            code: this.countryCode,
            mobile: this.models.mobile_number,
            country_name: this.models.country ? this.models.country : "us",
          };
        }

        this.profileService.getOtp(model_data).subscribe(
          (res) => {
            if (res) {
              this.spinner.hide();
              this.isLoading = false;
              this.dialog.closeAll();
              const dialogRef = this.dialog.open(OtpModelComponent, {
                width: "360px",
                data: res.results,
                panelClass: "otp-model",
              });
              this.router.events.subscribe(() => {
                dialogRef.close();
              });
              dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                  const userInfo = JSON.parse(
                    CryptoJS.AES.decrypt(
                      localStorage.getItem(environment.localStorageKey),
                      environment.secretkey
                    ).toString(CryptoJS.enc.Utf8)
                  );
                  userInfo.mobile_number = model_data.mobile;
                  userInfo.country = this.models.country;
                  const encryptData = CryptoJS.AES.encrypt(
                    JSON.stringify(userInfo),
                    environment.secretkey
                  ).toString();
                  localStorage.setItem(
                    environment.localStorageKey,
                    encryptData
                  );

                  this.onRefresh();
                  this.dialog.closeAll();
                  this.router.navigate(["/my-account/profile"]);
                }
              });
            }
          },
          (err) => {
            if (err) {
              this.btnDisable = false;
              this.isLoading = false;
              this.spinner.hide();
              this.toastr.error(err.error.message, "OOPS!", {
                closeButton: true,
              });
            }
          }
        );
      }
    }
  }

  telInputObject(obj) {
    if (this.model.country) {
      const country = this.model.country.slice(0, 2);
      obj.setCountry(country);
      this.models.country = country;
      if (this.model.country_code == null) {
        this.countryCode = 91;
      }
    } else {
      obj.setCountry("us");
      this.models.country = "us";
    }
  }

  getNumber(myNum) {
    this.phoneNumber = myNum;
  }

  onCountryChange(event) {
    this.models.country = event.iso2;
    this.countryCode = event.dialCode;
    if (this.model.mobile_number == this.mobile_number) {
      this.btnDisable = true;
      this.isNoSame = false;
    } else if (this.model.mobile_number !== this.mobile_number) {
      this.isNoSame = true;
      this.btnDisable = true;
    }
  }

  hasError(event) {
    this.ref.detectChanges();
    if (!event || this.model.mobile_number == this.mobile_number) {
      this.btnDisable = true;
    } else {
      this.btnDisable = false;
    }
  }

  onInputChange(event) {
    if (this.models.country === "in") {
      const value = event.split(0).join("");
      this.mobile_number = value.split(" ").join("");
    } else {
      this.mobile_number = event.replace(/[^a-zA-Z0-9]/g, "");
    }
    if (this.model.mobile_number == this.mobile_number) {
      this.btnDisable = true;
      this.isNoSame = false;
    } else if (this.model.mobile_number !== this.mobile_number) {
      this.isNoSame = true;
      this.btnDisable = true;
    }
  }
  checkError(eve) {
    if (eve.code == "Space") {
      const target = eve.target;
      target.blur();
    } else if (eve.code == "Enter") {
      const target = eve.target;
      target.blur();
    }
  }
  ngOnDestroy(): void {
    this.profileService.uploadedFile = "";
  }
  selectImage(): any {
    this.profileImage.nativeElement.value = "";
  }
}
